
import { useState } from "react";
import { useEffect } from "react";
import { Helper } from "../../functionality/helper";
import { apiRoutes, imgServices } from "../../functionality/apiRoutes";
function Services() {
    const [data , setData] = useState([])
    const [loading , setLoading] = useState(true)
    useEffect(()=>{
        const controller = new AbortController()
        const signal = controller.signal
        const getServices = async (signal)=>{
            setLoading(true)
            const {response , message} = await Helper({
                url : apiRoutes.home.getServices,
                method : "GET",
                signal
            })
            if(response){
                
                setData(response.data)
                setLoading(false)
            }
        }
        getServices(signal)
        return () => controller.abort()
    },[])
    return ( <div className="services  mt-5 md:mt-10">
        <div className="flex justify-center pt-10 pb-5">
           <h2> Our Services</h2>
        </div>
        {
            loading ?<div className='min-h-96 dynamic-pages w-full flex justify-center items-center'>
 
            <div style={{background:"white"}}  className="bounce"></div>
            <div style={{background:"white"}} className="bounce"></div>
            <div style={{background:"white"}} className="bounce"></div>
    
            </div>:<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                 {data.length >= 0 && data.map((ele)=>(<div key={`Services_${ele.name?ele.name:""}`} className="px-5 md:px-10">
                    <div className="px-5 md:px-10">
                        <div className="flex justify-center services-icon">
                            <img className="w-10" alt={ele.name?ele.name:""} src={imgServices + ele.image} />
                        </div>
                        <h5 className="flex justify-center py-4">{ele.name?ele.name:""}</h5>
                        <p dangerouslySetInnerHTML={{__html : ele.content?ele.content:""}} className="flex justify-center text-center"/>

                    </div>
                 </div>)) }
            

        </div>
        }
        
    </div> );
}

export default Services;